export default __webpack_public_path__ + "static/lab-8db1f8a75cfb4e6c212a5e9094592e61.jpg";